import * as THREE from 'three';

function resizeCanvas(origCanvas, width, height) {
  const resizedCanvas = document.createElement('canvas');
  const resizedContext = resizedCanvas.getContext('2d');

  let w = width,
    h = height,
    offsetX = 0;
  if (screen.width < screen.height) {
    w = height * (height / width);
    h = width * (height / width);
    offsetX = -(height - width);
  } else {
    w = width;
    h = height;
    offsetX = 0;
  }

  resizedCanvas.height = height;
  resizedCanvas.width = width;
  // screenshot border
  // resizedContext.lineWidth = 10;
  // resizedContext.strokeStyle = 'white';
  // resizedContext.strokeRect(0, 0, resizedCanvas.width, resizedCanvas.height);

  resizedContext.drawImage(origCanvas, offsetX, 0, w, h);
  // set image watermark in screenshot 350, 550 define  logo position and 80 and 35 used for logo  width and height
  resizedContext.fillText('Vossle', 383, 580);
  return resizedCanvas.toDataURL();
}

function resizeCanvasV2(origCanvas, width, height) {
  const resizedCanvas = document.createElement('canvas');
  const resizedContext = resizedCanvas.getContext('2d');

  resizedCanvas.width = width;
  resizedCanvas.height = height;

  // Calculate aspect ratios
  const canvasRatio = width / height;
  const origRatio = origCanvas.width / origCanvas.height;

  let drawWidth, drawHeight, offsetX, offsetY;

  if (origRatio > canvasRatio) {
    // Original is wider - fit to height
    drawHeight = height;
    drawWidth = height * origRatio;
    offsetX = (width - drawWidth) / 2;
    offsetY = 0;
  } else {
    // Original is taller - fit to width
    drawWidth = width;
    drawHeight = width / origRatio;
    offsetX = 0;
    offsetY = (height - drawHeight) / 2;
  }

  resizedContext.drawImage(origCanvas, offsetX, offsetY, drawWidth, drawHeight);
  // set image watermark in screenshot 350, 550 define  logo position and 80 and 35 used for logo  width and height
  return resizedCanvas.toDataURL();
}
// end of resizeCanvas function

function captureVideoFrame(videoId, format, width, height) {
  let video = document.getElementById(videoId);

  format = format || 'jpeg';

  if (!video || (format !== 'png' && format !== 'jpeg')) {
    return false;
  }

  const canvas = document.createElement('CANVAS');

  canvas.width = width || video.videoWidth;
  canvas.height = height || video.videoHeight;

  canvas.getContext('2d').drawImage(video, 0, 0);
  const dataUri = canvas.toDataURL('image/' + format);
  const data = dataUri.split(',')[1];
  const mimeType = dataUri.split(';')[0].slice(5);

  const bytes = window.atob(data);
  const buf = new ArrayBuffer(bytes.length);
  const arr = new Uint8Array(buf);

  for (let i = 0; i < bytes.length; i++) {
    arr[i] = bytes.charCodeAt(i);
  }

  const blob = new Blob([arr], { type: mimeType });
  return {
    blob: blob,
    dataUri: dataUri,
    format: format,
    width: canvas.width,
    height: canvas.height,
  };
}
//end of captureVideoFrame function

const defaultOptions = {
  format: 'image/png',
  quality: 0.92,
  width: undefined,
  height: undefined,
  Canvas: undefined,
  crossOrigin: undefined,
};

// Return Promise
var mergeImages = function (sources, options) {
  if (sources === void 0) sources = [];
  if (options === void 0) options = {};

  return new Promise(function (resolve) {
    options = Object.assign({}, defaultOptions, options);

    // Setup browser/Node.js specific variables
    const canvas = options.Canvas
      ? new options.Canvas()
      : window.document.createElement('canvas');
    const Image = options.Image || window.Image;

    // Load sources
    const images = sources.map(function (source) {
      return new Promise(function (resolve, reject) {
        // Convert sources to objects
        if (source.constructor.name !== 'Object') {
          source = { src: source };
        }

        // Resolve source and img when loaded
        const img = new Image();
        img.crossOrigin = options.crossOrigin;
        img.onerror = function () {
          return reject(new Error("Couldn't load image"));
        };
        img.onload = function () {
          return resolve(Object.assign({}, source, { img: img }));
        };
        img.src = source.src;
      });
    });

    // Get canvas context
    const ctx = canvas.getContext('2d');

    // When sources have loaded
    resolve(
      Promise.all(images).then(function (images) {
        // Set canvas dimensions
        const getSize = function (dim) {
          return (
            options[dim] ||
            Math.max.apply(
              Math,
              images.map(function (image) {
                return image.img[dim];
              })
            )
          );
        };
        canvas.width = getSize('width');
        canvas.height = getSize('height');

        // Draw images to canvas
        images.forEach(function (image) {
          ctx.globalAlpha = image.opacity ? image.opacity : 1;
          return ctx.drawImage(image.img, image.x || 0, image.y || 0);
        });

        if (options.Canvas && options.format === 'image/jpeg') {
          // Resolve data URI for node-canvas jpeg async
          return new Promise(function (resolve, reject) {
            canvas.toDataURL(
              options.format,
              {
                quality: options.quality,
                progressive: false,
              },
              function (err, jpeg) {
                if (err) {
                  reject(err);
                  return;
                }
                resolve(jpeg);
              }
            );
          });
        }

        // Resolve all other data URIs sync
        return canvas.toDataURL(options.format, options.quality);
      })
    );
  });
};

export const captureScene = async (
  videoId = 'arjs-video',
  sceneType = 'AFRAME'
) => {
  const videoElement = document.getElementById(videoId);
  videoElement.pause();
  const isARJS = videoId === 'arjs-video';
  if (!isARJS) {
    const sceneEl = document.querySelector('a-scene');

    const windowHeight = window.innerHeight;
    const windowWidth = window.innerWidth;
    sceneEl.setAttribute('screenshot', {
      width: windowWidth,
      height: windowHeight,
    });
  }
  // set bg gray color on click of sreeen capture button
  let canvas;
  if (sceneType === 'AFRAME') {
    canvas = document
      .querySelector('a-scene')
      .components.screenshot.getCanvas('perspective');
  } else {
    canvas = document.getElementsByTagName('canvas')[0];
  }
  let frame = captureVideoFrame(videoId, 'png');
  if (isARJS) {
    canvas = resizeCanvas(canvas, frame.width, frame.height);
  } else {
    canvas = resizeCanvasV2(canvas, frame.width, frame.height);
  }
  frame = frame.dataUri;
  return new Promise(resolve => {
    mergeImages([frame, canvas]).then(b64 => {
      resolve(b64);
    });
    videoElement.play();
  });
};

export const captureThreeScene = async (
  scene,
  camera,
  height,
  width,
  videoId
) => {
  document.querySelector('video').pause();

  let frame = captureVideoFrame(videoId, 'png');
  let tempCanvas = document.createElement('canvas');
  let tempRenderer = new THREE.WebGLRenderer({
    canvas: tempCanvas,
    preserveDrawingBuffer: true,
    antialias: true,
    alpha: true,
  });
  tempRenderer.setSize(width, height);
  tempRenderer.render(scene, camera);
  tempCanvas = resizeCanvas(tempCanvas, frame.width, frame.height);
  frame = frame.dataUri;
  return new Promise(resolve => {
    mergeImages([frame, tempCanvas])
      .then(b64 => {
        resolve(b64);
      })
      .finally(() => {
        tempRenderer.dispose();
        tempRenderer.forceContextLoss();
        tempCanvas.remove();
      });
    document.querySelector('video').play();
  });
};
